import Tooltip, { TooltipProps } from '@mui/material/Tooltip';

export const CustomTooltip = (props: TooltipProps) => (
  <Tooltip
    arrow
    componentsProps={{
      tooltip: {
        sx: {
          backgroundColor: 'background.white',
          color: '#000',
          fontSize: 16,
          padding: 2,
          boxShadow: 1,
        },
      },
      arrow: {
        sx: {
          color: 'background.white',
        },
      },
    }}
    {...props}
  >
    {props.children}
  </Tooltip>
);
